import { nativeEnum, object, array, number, enum as zenum, preprocess } from 'zod';

import { Site_System_Connection_Action, Site_System_Connection_Status } from '@occc/graphql';
import { DateTimeForFilterSchema, TimeRangeEnum } from '@occc/ui-forms';

// Create a reusable enum for Operators
// https://refine.dev/docs/core/interface-references/#conditionalfilter
const NUMBER_OPERATORS = ['gte', 'lte'] as const;
export const ConnectionDurationOperatorEnum = zenum(NUMBER_OPERATORS);

export const ConnectionHistoryFilterSchema = object({
  connectionStatusEquals: nativeEnum(Site_System_Connection_Status).optional(),
  lastConnectedAt: TimeRangeEnum.optional(),
  lastConnectDateFrom: DateTimeForFilterSchema.optional(),
  lastConnectDateTo: DateTimeForFilterSchema.optional(),
  lastDisconnectedAt: TimeRangeEnum.optional(),
  lastDisconnectDateFrom: DateTimeForFilterSchema.optional(),
  lastDisconnectDateTo: DateTimeForFilterSchema.optional(),
  connectionDurationOperator: ConnectionDurationOperatorEnum.optional(),
  connectionDurationSeconds: preprocess((val) => {
    if (val === null || val === undefined) {
      return undefined;
    }
    if (typeof val === 'number') {
      return val;
    }
    if (typeof val === 'string' && !val) {
      return undefined;
    }
    return Number(val);
  }, number().positive().optional()),
  disconnectActionContains: array(nativeEnum(Site_System_Connection_Action)).optional(),
});
